import styled from "styled-components";

export const AeroplanContainer = styled.div`
  margin-top: 20px;
  padding: 20px 0;
  border-top: 1px solid #333;
`;

export const AeroplanText = styled.p`
  font-size: 20px;
  color: #333;
  margin-bottom: 16px;

  @media only screen and (max-width: 550px) {
    font-size: 18px;
  }
`;

export const AeroplanHeadingContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;
`;

export const AeroplanLogo = styled.img`
  display: block;
  width: 170px;
  height: 23px;
  margin-right: 20px;
`;
